import { css } from '@emotion/react';
import { motion, AnimatePresence } from 'motion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { CALL_BAR_HEIGHT } from '../call-bar/constants';

export const IncomingCallBarPreview = ({
  onClick,
  numOfIncomingCalls,
  animationX: x,
}: {
  onClick: () => void;
  numOfIncomingCalls: number;
  animationX: number;
}) => {
  const { t } = useTranslation('softphone');

  return (
    <AnimatePresence>
      <motion.section
        initial={{ x, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x, opacity: 0 }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
        id='softphone-incoming-call-bar-preview'
        css={incomingCallBarPreviewStyles}
        onClick={onClick}
      >
        <Text size='medium' weight='bold' css={{ color: theme.colors.success30 }}>
          {t('+{{count}} New', { count: numOfIncomingCalls })}
        </Text>
        <Icon name='caret-right-small' color='white' />
      </motion.section>
    </AnimatePresence>
  );
};

const incomingCallBarPreviewStyles = css`
  background-color: ${theme.colors.neutral90};
  border-radius: ${theme.borderRadius.medium};
  min-width: 111px;
  padding: ${theme.spacing(1, 2)};
  box-shadow: 0 0 8px 4px rgba(8, 135, 63, 0.5);
  height: ${CALL_BAR_HEIGHT}px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  &:hover {
    background-color: ${theme.colors.success50};
    * {
      color: white;
    }
  }
`;
